import {
  Broadcast, Envelope, Scales, Gavel, Briefcase, Cloud,
  Handshake, Compass, Kanban, Lightning, Cube, HardDrive,
} from "@phosphor-icons/react";

// Human-readable metadata for every destination type LeadFlow can dispatch to.
// The `Icon` is a phosphor-icon component used in both the type-picker grid
// and the destination table.
export const TYPE_META = {
  webhook:        { label: "Webhook",    Icon: Broadcast, help: "Signed POST to any REST endpoint" },
  email:          { label: "Email",      Icon: Envelope,  help: "Formatted HTML email via Resend" },
  crm_lawmatics:  { label: "Lawmatics",  Icon: Scales,    help: "Form submit + Bearer OAuth token" },
  crm_lawruler:   { label: "Law Ruler",  Icon: Gavel,     help: "Legal CRM API key (in payload)" },
  crm_leaddocket: { label: "Lead Docket",Icon: Briefcase, help: "Form endpoint (no auth needed)" },
  crm_salesforce: { label: "Salesforce", Icon: Cloud,     help: "REST Composite endpoint (Bearer token)" },
  crm_litify:     { label: "Litify",     Icon: Cloud,     help: "Litify_pm__Intake__c REST endpoint" },
  crm_hubspot:    { label: "HubSpot",    Icon: Handshake, help: "Contacts v3 API — Private App token or OAuth" },
  crm_zoho:       { label: "Zoho CRM",   Icon: Compass,   help: "Leads v8 API — OAuth refresh (region-aware)" },
  crm_pipedrive:  { label: "Pipedrive",  Icon: Kanban,    help: "Persons v2 API — API token" },
  crm_zapier:     { label: "Zapier / Make", Icon: Lightning, help: "Universal catch-hook — fan out to any of 5,000+ apps" },
  s3:             { label: "S3",         Icon: Cube,      help: "Writes {lead_id}.json to your bucket" },
  ftp:            { label: "FTP",        Icon: HardDrive, help: "STOR {lead_id}.json to remote directory" },
};

// Every field the destination form ever touches, initialised empty. Keeping
// them in one object means we can safely spread the fresh config on reset.
export const BLANK_CONFIG = {
  url: "", method: "POST", secret: "", to: "", subject: "",
  template: "", reply_to: "", state_allowlist: "", state_fees_text: "",
  daily_digest_enabled: false, daily_digest_recipient: "",
  // Iter-30: Buyer invoicing config
  payment_mode: "prepay", invoice_enabled: false, invoice_recipient: "",
  endpoint: "", auth_token: "", api_key: "", lead_provider: "", content_type: "",
  // Pipedrive
  api_token: "", owner_id: "",
  // Zoho
  zoho_region: "com", module: "Leads", default_company: "",
  // OAuth refresh flow (Salesforce / Lawmatics / Litify / HubSpot / Zoho)
  oauth_mode: false, oauth_client_id: "", oauth_client_secret: "",
  oauth_refresh_token: "", oauth_token_url: "",
  bucket: "", region: "us-east-1", access_key_id: "", secret_access_key: "", prefix: "",
  host: "", port: 21, username: "", password: "", directory: "", use_tls: false,
};

// Default OAuth2 token URLs per provider — used to auto-fill the field when
// the operator flips into OAuth-mode. Zoho's is region-aware and derived
// separately in DestinationForm.
export const OAUTH_TOKEN_URLS = {
  crm_salesforce: "https://login.salesforce.com/services/oauth2/token",
  crm_litify:     "https://login.salesforce.com/services/oauth2/token",
  crm_lawmatics:  "https://api.lawmatics.com/oauth/token",
  crm_hubspot:    "https://api.hubapi.com/oauth/v1/token",
  crm_zoho:       "https://accounts.zoho.com/oauth/v2/token",
};
